module.exports = __webpack_public_path__ + "static/media/ic_emptyBag2.b196cc18.png";